import { Person } from './person';
import { Status } from './status';
import { Attachable } from './attachable';
import { Comment as IssueComment } from './comment';
import { Issue } from './issue';
import { CriticalLevel } from './enums/criticalLevel';
import { IssueType } from './enums/issueType';
import { Sticker } from './sticker';
import { IssueLink } from './issueLink';

export class Task implements Issue {

  public id: number;
  public summary: string;
  public description: string;
  public estimate: number;
  public time_spent: number;
  public assignee: Person;
  public reporter: Person;
  public status: Status;
  public parentIssueId: number;
  public attachments: Attachable[];
  public comments: IssueComment[];
  public storyPoints: number = null;
  public isSubissue = true;
  public issueType: IssueType.SUBTASK;
  public changelog: string[];
  public created: string;
  public criticalLevel: CriticalLevel;
  public isHighlighted: boolean;
  public isVisible: boolean;
  public stickers: Sticker[] = [];
  public isExpedited: boolean;
  public issueLinks: IssueLink[] = [];
  public updatedAt: string;
  public lastViewed: string;
  public lastViewedInAwall: string;

  public constructor(id: number, summary: string, description: string, estimate: number, time_spent: number, assignee: Person,
    reporter: Person, status: Status, parentIssueId: number, attachments: Attachable[], changelog: string[], created: string,
    isExpedited: boolean, issueLinks: IssueLink[], updatedAt: string, lastViewed: string, lastViewedInAwall: string){
    this.id = id;
    this.summary = summary;
    this.description = description;
    this.estimate = estimate;
    this.time_spent = time_spent;
    this.assignee = assignee;
    this.reporter = reporter;
    this.status = status;
    this.parentIssueId = parentIssueId;
    this.attachments = attachments;
    this.changelog = changelog;
    this.created = created;
    this.criticalLevel = CriticalLevel.None;
    this.isVisible = true;
    this.isExpedited = isExpedited;
    this.issueLinks = issueLinks;
    this.updatedAt = updatedAt;
    this.lastViewed = lastViewed;
    this.lastViewedInAwall = lastViewedInAwall;
  }

  public update(other: Task) {
    this.id = other.id;
    this.summary = other.summary;
    this.description = other.description;
    this.estimate = other.estimate;
    this.time_spent = other.time_spent;
    this.assignee = other.assignee;
    this.reporter = other.reporter;
    this.status = other.status;
    this.parentIssueId = other.parentIssueId;
    this.attachments = other.attachments;
    // TODO check if update happen with the same task (if not changelog must be consistence)
    this.changelog = other.changelog;
    this.created = other.created;
    this.criticalLevel = other.criticalLevel;
    this.isVisible = other.isVisible;
    this.isHighlighted = other.isHighlighted;
    this.isExpedited = other.isExpedited;
    this.updatedAt = other.updatedAt;
    this.lastViewed = other.lastViewed;
    this.lastViewedInAwall = other.lastViewedInAwall;
  }

  public getCopy(): Task {
    const copy: Task = new Task(this.id, this.summary, this.description, this.estimate,
      this.time_spent, this.assignee, this.reporter, this.status, this.parentIssueId, this.attachments, this.changelog, this.created,
      this.isExpedited, this.issueLinks, this.updatedAt, this.lastViewed, this.lastViewedInAwall);
    copy.isVisible = this.isVisible;
    copy.isHighlighted = this.isHighlighted;
    copy.criticalLevel = this.criticalLevel;
    return copy;
  }

  isCritical() {
    return this.criticalLevel === CriticalLevel.Critical;
  }
  isWarning() {
    return this.criticalLevel === CriticalLevel.Warning;
  }
}

/**
 * the PyWall needs a different formatting from us that he gives us
 * this class maps the data to a format the PyWall expects
 */
export class UpdateTask {
  id: number;
  name: string; // task.summary
  summary: string; // task.summary
  description: string;
  estimate: number;
  time_spent: number;
  assignee: object; // assignee.id
  reporter: object; // assignee.id
  status: object; // state id
  parent_issue_id: number; // userstory id
  attachments: number[];
  changelog: string[];
  created: string;
  isExpedited: boolean;
  issuetype: string;
  updatedAt: string;
  lastViewed: string;
  last_viewed_in_awall: string;

  constructor(task: Task) {
    this.id = task.id;
    this.name = task.summary;
    this.summary = task.summary;
    this.description = task.description;
    this.estimate = task.estimate;
    this.time_spent = task.time_spent;
    this.assignee = (task.assignee) ? {'id': task.assignee.id} : null;
    this.reporter = (task.reporter) ? {'id': task.reporter.id} : null;
    this.status = {'id': task.status.id};
    this.parent_issue_id = task.parentIssueId;
    this.attachments = task.attachments.map(a => a.id);
    this.changelog = [];
    this.created = task.created;
    this.isExpedited = task.isExpedited;
    this.issuetype = 'Sub-task';
    this.updatedAt = task.updatedAt;
    this.lastViewed = task.lastViewed;
    this.last_viewed_in_awall = task.lastViewedInAwall;
  }
}
